import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DespachanteService } from 'app/services/despachante.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-despachante-form',
  templateUrl: './despachante-form.component.html',
  styleUrls: ['./despachante-form.component.scss']
})
export class DespachanteFormComponent implements OnInit {
  public id_despachante: number;
  public nome: string;
  public cnpj: string;
  public telefone: string;
  public email: string;
  public endereco: string;
  public isLoading = false;
  public flg_status: number = 1;

  public href;
  public contentHeader: object;
  private routeSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private despachanteService: DespachanteService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.href = this.route.url;

    if (this.href.value[1].path == "cadastro") {
      this.contentHeader = {
        headerTitle: "Cadastrar Despachante",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            { name: "Início", isLink: false },
            { name: "Despachante", isLink: false },
            { name: "Cadastrar", isLink: false }
          ]
        }
      };
    }

    if (this.href.value[1].path == "editar") {
      this.routeSub = this.route.params.subscribe(async (params) => {
        try {
          const despachante = await this.despachanteService.getOne(params["id"]);
          
          this.id_despachante = params["id"];
          this.nome = despachante.nome;
          this.cnpj = despachante.cnpj;
          this.telefone = despachante.telefone;
          this.email = despachante.email;
          this.endereco = despachante.endereco;
          this.flg_status = despachante.flg_status || 1;
        } catch (error) {
          console.error('Erro ao carregar despachante:', error);
          Swal.fire({
            title: "Erro!",
            text: "Não foi possível carregar os dados do despachante.",
            icon: "error",
            confirmButtonText: "Ok"
          }).then(() => {
            this._router.navigate(['despachante']);
          });
        }
      });

      this.contentHeader = {
        headerTitle: "Editar Despachante",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            { name: "Início", isLink: false },
            { name: "Despachante", isLink: false },
            { name: "Editar", isLink: false }
          ]
        }
      };
    }
  }

  public async submitForm(form: NgForm) {
    if (form.form.valid) {
      this.isLoading = true;
      try {
        const isCreate = this.href.value[1].path === "cadastro";
        const message = isCreate ? "cadastrado" : "atualizado";
        
        const response = isCreate
          ? await this.despachanteService.post(form.value)
          : await this.despachanteService.patch(form.value, this.id_despachante);

        await Swal.fire({
          title: "Sucesso!",
          text: `O despachante foi ${message}.`,
          icon: "success",
          confirmButtonText: "Confirmar"
        });
        
        this._router.navigate(['despachante']);
      } catch (error) {
        console.error('Erro na operação:', error);
        await Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao processar a requisição.",
          icon: "error",
          confirmButtonText: "Ok"
        });
      } finally {
        this.isLoading = false;
      }
    }
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
